<script>
export default {
  name: "DidoChipsCollapsibleList",
};
</script>

<script setup>
import { ref } from "vue";
import DidoChipsList from "./List.vue";

// define Props
const props = defineProps({
  items: { type: Array, required: true },
  type: { type: String, required: true },
  fromDatasetOrDatafile: { type: String, required: true },
  itemsWhenCollapsed: { type: Number, required: false, default: 5 },
  size: { type: String, required: false, default: "sm" },
  outline: { type: Boolean, required: false, default: false },
  bgColor: { type: String, required: false, default: "secondary" },
  textColor: { type: String, required: false, default: "white" },
  icon: { type: String, required: false, default: null },
});

// define events emitted
const emit = defineEmits(["label-selection"]);

// ref for state of swith button
const showMore = ref(false);
</script>

<template>
  <span>
    <DidoChipsList
      :type="props.type"
      :from-dataset-or-datafile="props.fromDatasetOrDatafile"
      :items="props.items.slice(0, props.itemsWhenCollapsed)"
      :size="props.size"
      :bg-color="props.bgColor"
      :text-color="props.textColor"
      :outline="props.outline"
      :icon="props.icon"
      @label-selection="($event) => emit('label-selection', $event)"
    />
    <DidoChipsList
      v-if="items.length > props.itemsWhenCollapsed && showMore"
      :type="props.type"
      :from-dataset-or-datafile="props.fromDatasetOrDatafile"
      :items="props.items.slice(props.itemsWhenCollapsed)"
      :size="props.size"
      :bg-color="props.bgColor"
      :text-color="props.textColor"
      @label-selection="($event) => emit('label-selection', $event)"
    />
    <QChip
      v-if="props.items.length > props.itemsWhenCollapsed"
      :icon="`mdi-${showMore ? 'minus' : 'plus'}-circle`"
      :size="props.size"
      :label="`voir ${showMore ? 'moins' : 'plus'}`"
      square
      outline
      :color="props.bgColor"
      :title="showMore ? 'Voir moins d\'éléments' : 'Voir plus d\'éléments'"
      clickable
      @click="showMore = !showMore"
    />
  </span>
</template>
